import {useRef} from 'react';


export default function useLatestRef<T>(value: T) {
    const ref = useRef<T>(value);
    ref.current = value;
    // useIsomorphicLayoutEffect(() => {
    //     valueRef.current = value;
    // }, dependencies);

    return ref;
}
